import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import propertiesActions from '../properties2/actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';
import isEmpty from 'lodash/isEmpty';

// DO_GET_PROPERTY_VIEWING_PREFERENCES
const doGetPropertyViewingPreferences = async hash => {
  return await SuperFetch.post(`${apiUrls.getPropertyPreferences}?hash=${hash}`, { data: {} })
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getPropertyViewingPreferences(action) {
  const response = yield call(doGetPropertyViewingPreferences, action.payload);
  if ( response && !isEmpty(response) && !response.error ) {
    yield put(actions.doGetPropertyViewingPreferencesSuccess(response));
  } else {
    yield put(actions.doGetPropertyViewingPreferencesFailed(response));
  }
}

// DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE
const doGetPropertyViewingPreferencesSingle = async hash => {
  return await SuperFetch.post(`${apiUrls.getPropertyPreferencesSingle}?hash=${hash}`, { data: {} })
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getPropertyViewingPreferencesSingle(action) {
  const response = yield call(doGetPropertyViewingPreferencesSingle, action.payload);
  if ( response && !isEmpty(response) && !response.error ) {
    yield put(actions.doGetPropertyViewingPreferencesSingleSuccess(response));
  } else {
    yield put(actions.doGetPropertyViewingPreferencesSingleFailed(response));
  }
}

// DO_SAVE_LANDLORD_ENTITY_PREFERENCES
const doSaveLandlordEntitityPreferences = async payload => {
  return await SuperFetch.post(apiUrls.landlordSaveEntityPreferences, { data: payload })
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* saveLandlordEntitityPreferences(action) {
  const response = yield call(doSaveLandlordEntitityPreferences, action.payload);
  if ( response && !isEmpty(response) && !response.error ) {
    yield put(actions.doLandlordSaveEntityPreferencesSuccess(response));
  } else {
    yield put(actions.doLandlordSaveEntityPreferencesFailed(response));
  }
}

// DO_ADD_PROPERTY_VIEWING_PREFERENCE
const doSaveLandlordViewingPreferences= async payload => {
  const hash = payload.hash ? `?hash=${payload.hash}` : '';
  return await SuperFetch.post(apiUrls.addPropertyPreference + hash, { data: payload })
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* saveLandlordViewingPreferences(action) {
  const response = yield call(doSaveLandlordViewingPreferences, action.payload);
  if ( response && !isEmpty(response) && !response.error ) {
    yield put(actions.doAddPropertyViewingPreferenceSuccess(response));
  } else {
    yield put(actions.doAddPropertyViewingPreferenceFailed(response));
  }
}

// DO_DELETE_PROPERTY_VIEWING_PREFERENCE
const doDeleteLandlordViewingPreferences = async payload => {
  const hash = payload.hash ? `?hash=${payload.hash}` : '';
  return await SuperFetch.post(apiUrls.deletePropertyPreference + hash, { data: payload })
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* deleteLandlordViewingPreferences(action) {
  const response = yield call(doDeleteLandlordViewingPreferences, action.payload);
  if ( response ) {
    // use the doDeleteLandlordViewingPreferences payload, as the reponse diesn't give us anything
    yield put(actions.doDeletePropertyViewingPreferenceSuccess(action.payload));
  } else {
    yield put(actions.doDeletePropertyViewingPreferenceFailed(action.payload));
  }
}

// DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE
const doSaveLandlordViewingPreferencesSingle = async payload => {
  const hash = payload.hash ? `?hash=${payload.hash}` : '';
  return await SuperFetch.post(apiUrls.addPropertyPreferenceSingle + hash, { data: payload })
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* saveLandlordViewingPreferencesSingle(action) {
  const response = yield call(doSaveLandlordViewingPreferencesSingle, action.payload);
  if ( response && !isEmpty(response) && !response.error ) {
    yield put(actions.doAddPropertyViewingPreferenceSingleSuccess(response));
  } else {
    yield put(actions.doAddPropertyViewingPreferenceSingleFailed(response));
  }
}

// DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE
const doDeleteLandlordViewingPreferencesSingle = async payload => {
  const hash = payload.hash ? `?hash=${payload.hash}` : '';
  return await SuperFetch.post(apiUrls.deletePropertyPreferenceSingle + hash, { data: payload })
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* deleteLandlordViewingPreferencesSingle(action) {
  const response = yield call(doDeleteLandlordViewingPreferencesSingle, action.payload);
  if ( response ) {
    // use the doDeleteLandlordViewingPreferencesSingle payload, as the response doesn't give us anything
    yield put(actions.doDeletePropertyViewingPreferenceSingleSuccess(action.payload));
  } else {
    yield put(actions.doDeletePropertyViewingPreferenceSingleFailed(action.payload));
  }
}

// DO_GET_PROPERTY_LISTING_PRICE
const doGetPropertyAdvertisePrice = async payload => {
  return await SuperFetch.post(`${apiUrls.getListingPrice}`, payload)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getPropertyListingPrice(payload) {
  const propertyListingPrice = yield call(doGetPropertyAdvertisePrice, payload.payload);
  yield [
    put(actions.doGetPropertyListingPriceSucceeded(propertyListingPrice))
  ];
}

// DO_MAKE_STRIPE_ADVERTISE_PAYMENT
const doMakeStripeAdvertisingPayment = async payload => {
  const postData = {
    data: {
      cardname: payload.payload.cardName,
      llid: null,
      code: payload.payload.code
    }
  };
  return await SuperFetch.post(`${apiUrls.landlordMakeStripePayment}?pst=${payload.payload.token.id}`, postData)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* makeStripeAdvertisingPayment(payload) {
  const payment = yield call(doMakeStripeAdvertisingPayment, payload);
  yield [
    put(actions.doMakeStripeAdvertisePaymentSucceeded(payment)),
    put(actions.doAddPropertyToPortalQueue(payload))
  ];
}

// DO_ADD_PROPERTY_TO_PORTAL_QUEUE
const doAddPropertyToPortalQueue = async payload => {
  let propertyHash;
  let slotHash;
  if(payload.payload.data) {
    slotHash = payload.payload.data.rentalDataHash;
  } else {
    slotHash = payload.payload.payload.slotHash;
  }
  const postData = {
    data: {
      rentalDataHash: slotHash,
    }
  };
  return await SuperFetch.post(apiUrls.landlordAddPropertyToPortalQueue, postData)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* addPropertyToPortalQueue(payload) {
  const addtoportal = yield call(doAddPropertyToPortalQueue, payload);  
  if (addtoportal) {
    yield [
      put(propertiesActions.doGetPropertySlotData())
    ];
  }
}

// DO_REMOVE_PROPERTY_FROM_PORTAL_QUEUE
const doRemovePropertyFromPortalQueue = async payload => {
  return await SuperFetch.post(apiUrls.landlordRemovePropertyFromPortalQueue, payload.payload)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* removePropertyFromPortalQueue(payload) {
  const removefromportal = yield call(doRemovePropertyFromPortalQueue, payload);
  if (removefromportal) {
    // yield [
    //   put(actions.doMakeStripeAdvertisePaymentSucceeded(payment))
    // ];
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DO_GET_PROPERTY_VIEWING_PREFERENCES, getPropertyViewingPreferences),
    takeEvery(actions.DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE, getPropertyViewingPreferencesSingle),
    takeEvery(actions.DO_SAVE_LANDLORD_ENTITY_PREFERENCES, saveLandlordEntitityPreferences),
    takeEvery(actions.DO_ADD_PROPERTY_VIEWING_PREFERENCE, saveLandlordViewingPreferences),
    takeEvery(actions.DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE, saveLandlordViewingPreferencesSingle),
    takeEvery(actions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE, deleteLandlordViewingPreferences),
    takeEvery(actions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE, deleteLandlordViewingPreferencesSingle),
    takeEvery(actions.DO_GET_PROPERTY_LISTING_PRICE, getPropertyListingPrice),
    takeEvery(actions.DO_MAKE_STRIPE_ADVERTISE_PAYMENT, makeStripeAdvertisingPayment),
    takeEvery(actions.DO_ADD_PROPERTY_TO_PORTAL_QUEUE, addPropertyToPortalQueue),
    takeEvery(actions.DO_REMOVE_PROPERTY_FROM_PORTAL_QUEUE, removePropertyFromPortalQueue),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/propertiesAdvertise/sagas.js